import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=50d60a2e&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('50d60a2e', component.options)
    } else {
      api.reload('50d60a2e', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=50d60a2e&", function () {
      api.rerender('50d60a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EquiposEnTerreno/VerDetalleModal.vue"
export default component.exports